import { render, staticRenderFns } from "./cDocumentDashboardView.vue?vue&type=template&id=508d490e&scoped=true"
import script from "./cDocumentDashboardView.vue?vue&type=script&lang=js"
export * from "./cDocumentDashboardView.vue?vue&type=script&lang=js"
import style0 from "./cDocumentDashboardView.vue?vue&type=style&index=0&id=508d490e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d490e",
  null
  
)

export default component.exports